import styled from "@emotion/styled";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useMemo, useState } from "react";
import { Card } from "react-bootstrap";

import ToolsAPI from "../api/tools";
import Banner from "../components/layouts/banner";
import Loading from "../components/Loading";

const LinkContainer = styled.div`
    a:hover .card {
        background-color: rgba(0, 0, 0, 0.05);
    }

    .text-truncate-2 {
        -webkit-box-orient: vertical;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
    }
`;

const ToolPage = () => {
    const [list, setList] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(() => true);
        ToolsAPI.all()
            .then((response) => setList(() => response.data))
            .finally(() => setLoading(() => false));
    }, []);

    return (
        <LinkContainer>
            <Banner />

            <div className="container my-5">
                {loading && <Loading />}
                {!loading && (
                    <div className="d-flex flex-wrap gap-3 justify-content-center">
                        {list.map((v, i) => (
                            <a key={i} href={v.link} target="_blank">
                                <Card style={{ maxWidth: 300, minWidth: 150, height: 150, color: v.color, borderColor: v.color }}>
                                    <Card.Body className="d-flex flex-column justify-content-center text-center">
                                        <div>
                                            <FontAwesomeIcon icon={["fas", v.icon]} size="3x" />
                                        </div>
                                        <div className="mt-2 fs-6 fw-light text-truncate-2">{v.name}</div>
                                    </Card.Body>
                                </Card>
                            </a>
                        ))}
                    </div>
                )}
            </div>
        </LinkContainer>
    );
};

export default ToolPage;
